// Copyright © 2019-2026 Focal Systems. All rights reserved.

import type { ReactNode } from "react";
import { useAssistantFootprint } from "@/features/assistant/footprint";
import { cn } from "@/lib/utils";

/** The page's scroll container. While the assistant launcher floats over its bottom-right corner,
 * extra bottom room lets the last rows and the pagination scroll clear of it. */
export function MainScrollArea({ children }: { children: ReactNode }) {
  const launcherShown = useAssistantFootprint().kind !== "hidden";
  return (
    <div
      id="main-scrollable-area"
      className={cn("flex-1 overflow-y-auto overscroll-y-contain", launcherShown && "pb-20")}
    >
      {children}
    </div>
  );
}
